export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-09.8f38a65a.jpg";